/* Progressive enhancement: jump links to each H2 on long text pages. No-op without JS. */
(function () {
  var root = document.querySelector('[data-tt-jump]');
  if (!root) return;
  var heads = root.querySelectorAll('h2');
  if (heads.length < 3) return;
  var nav = document.createElement('nav');
  nav.className = 'tt-reading__jump';
  var label = root.getAttribute('data-tt-jump-label');
  if (label) nav.setAttribute('aria-label', label);
  var list = document.createElement('ul');
  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'tt-q-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  nav.appendChild(list);
  root.insertBefore(nav, root.firstChild);
})();
